export const SITE_URL = 'https://unlock.att.com/hbomax'

export default {
  SITE_URL
}